import axios, { getStandardAxiosConfig } from '../../util/api';

class OrgAdminAPI {
  static fetchOrgs () {
    return axios.get('/org', getStandardAxiosConfig());
  }
  static fetchOrg (id) {
    return axios.get('/org/' + id, getStandardAxiosConfig());
  }
  static updateOrg (org) {
    return axios.post(
      `/org/${org.id}`,
      { ...org },
      getStandardAxiosConfig()
    );
  }
  static deleteOrg (org) {
    return axios.delete(
      `/org/${org.id}`,
      getStandardAxiosConfig()
    );
  }
  static addUser (email, orgId) {
    return axios.post(
      `/orgs/authorise-user`,
      { email, orgId },
      getStandardAxiosConfig()
    );
  }
}

export default OrgAdminAPI;
